export const GET_ARTICLES_LIST = 'GET_ARTICLES_LIST';
export const GET_ARTICLE = 'GET_ARTICLE';
export const CLEAN_ARTICLE = 'CLEAN_ARTICLE';
